import {SearchError} from './SearchError.js'

export class GetFaqsForUrlSearchError extends SearchError {
  static create(message) {
    return new GetFaqsForUrlSearchError(message)
  }

  static createNotFound(message) {
    return new GetFaqsForUrlSearchError(message || 'FAQs not found for target URL')
  }

  static createNoContent(message) {
    return new GetFaqsForUrlSearchError(message || 'No FAQs available for this URL')
  }
}
